import type { AwardsAndRecognitionItem } from "./AwardsAndRecognition.types";

export const AWARDS_AND_RECOGNITION: AwardsAndRecognitionItem[] = [
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Awwwards Site of the Day",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Awwwards Developer Award",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Awwwards Honorable Mention",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "FWA of the Day",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Godly",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Muzli Portfolio Design Inspiration",
    year: "2022",
  },
  {
    project: "Richard Ekwonye Portfolio",
    platform: "Codrops Inspirational Websites Roundup",
    year: "2022",
  },
];
